import React from "react";
import { Dropdown } from "antd";
import { Link } from "react-router-dom";

import routes from "../routes";
import "./styles.scss";

const HeaderMenu = (props) => {
  const { location } = props;
  let moreListRoutes = [];
  routes
    .filter((inMore) => inMore.showin_more)
    .map((item) => {
      moreListRoutes.push(item.path);
      if (item.SubMenu) {
        item.subMenus.map((subItem) => {
          moreListRoutes.push(subItem.path);
          return null;
        });
      }
      return null;
    });

  const getMoreText = () => {
    let route = routes
      .filter((inMore) => inMore.showin_more)
      .filter((item) => `/${location?.pathname.split("/")[1]}`.includes(item.path));
    if (route.length > 0) {
      return <><span>{route[0].label}</span>
      <div className="arrow-up"></div> </>;
    } else {
      return <span>Other</span>;
    }
  };

  return (
    <div className="header_navs">
      <div className="menu_listing">
        {routes
          .filter((mainItem) => mainItem.showInHeader)
          .map((item) => (
            <div
              key={`menu${item.label}`}
              className={
                `/${location?.pathname.split("/")[1]}`.includes(item.path)
                  ? "menu_item active_nav"
                  : "menu_item"
              }
            >
              <span className="nav_img">
                <img src={item.image} alt="" />
              </span>
              <Link to={item.path}>{item.label}</Link>
              {`/${location?.pathname.split("/")[1]}`.includes(item.path) && (
                <div className="arrow-up"></div>
              )}
            </div>
          ))}
        <div className="menu_item">
          <Dropdown
            size="large"
            style={{ cursor: "pointer" }}
            menu={{
              items: routes
                .filter((inMore) => inMore.showin_more)
                .map((item) => {
                  return {
                    label: (
                      <div
                        className={
                          `/${location?.pathname.split("/")[1]}`.includes(item.path)
                            ? "dd_items active_ddlist"
                            : "dd_items"
                        }
                      >
                        <Link to={item.path} className="more-link-text">
                          {item.label}
                        </Link>
                      </div>
                    ),
                    key: item.label,
                  };
                }),
            }}
            trigger={["click"]}
          >
            <div className="dot-dropdown2">
              <div className="dropdown">
                <button
                  type="button"
                  className={
                    moreListRoutes.includes(`/${location?.pathname.split("/")[1]}`)
                      ? "dropbtn active_morenav"
                      : "dropbtn"
                  }
                >
                  <div className="dot_symbol">...</div>
                  {getMoreText()}
                </button>
              </div>
            </div>
          </Dropdown>
          
          
            
        </div>
      </div>
    </div>
  );
};
export default HeaderMenu;
